// 政策类型
export const POLICY_TYPE_LIST = [
  { label: '安全点位', value: '1' },
  { label: 'BEST', value: '2' },
];

// 来源
export const SOURCE_TYPE_LIST = [
  { label: '全部', value: '' },
  { label: 'GDT', value: 'GDT' },
  { label: 'MP', value: 'MP' },
  { label: 'GDT-品商补录', value: 'GDT-品商补录' },
  { label: 'MP-品商补录', value: 'MP-品商补录' },
  { label: 'MP-手工上报', value: 'MP-手工上报' },
  { label: 'MP-特殊调整', value: 'MP-特殊调整' },
];

// 资金账户类型
export const FINANCE_ACCOUNT_TYPE_LIST = [
  { label: '虚拟账户', value: '虚拟账户' },
  { label: '赠送账户', value: '赠送账户' },
  { label: 'COMPENSATE', value: 'COMPENSATE' },
  { label: '滚动信用账户', value: '滚动信用账户' },
  { label: '现金账户', value: '现金账户' },
  { label: '临时信用账户', value: '临时信用账户' },
  { label: '分成账户', value: '分成账户' },
  { label: '合约滚动信用账户', value: '合约滚动信用账户' },
  { label: 'GIFT_RESTRICT', value: 'GIFT_RESTRICT' },
  { label: 'SCHDL_COMPENSATE', value: 'SCHDL_COMPENSATE' },
];

// 投放模式
export const DELIVERY_MODE_LIST = [
  { label: '全部', value: '' },
  { label: '合约', value: '合约' },
  { label: '竞价', value: '竞价' },
];

// 累框标签
export const LKBQ_LIST = [
  { label: 'K1', value: 'K1' },
  { label: 'K2', value: 'K2' },
  { label: 'K3', value: 'K3' },
  { label: 'K4', value: 'K4' },
  { label: 'K5', value: 'K5' },
  { label: '封闭-房产', value: '封闭-房产' },
  { label: '封闭-区域汽车', value: '封闭-区域汽车' },
  { label: '封闭-区域运营商', value: '封闭-区域运营商' },
  { label: '封闭-招商加盟', value: '封闭-招商加盟' },
  { label: '附近推', value: '附近推' },
  { label: '其它业绩', value: '其它业绩' },
];

// k框修正列
export const K_FRAME_XZ_LIST = [
  { label: 'K1', value: 'K1' },
  { label: 'K2', value: 'K2' },
  { label: 'K3', value: 'K3' },
  { label: 'K4', value: 'K4' },
  { label: 'K5', value: 'K5' },
  { label: '封闭-房产', value: '封闭-房产' },
  { label: '封闭-区域汽车', value: '封闭-区域汽车' },
  { label: '封闭-区域运营商', value: '封闭-区域运营商' },
  { label: '封闭-招商加盟', value: '封闭-招商加盟' },
  { label: '其它业绩', value: '其它业绩' },
];

// 返点返货
export const RETURN_POINT_GOODS_LIST = [
  { label: '全部', value: '' },
  { label: '返点', value: '返点' },
  { label: '返货', value: '返货' },
];

// 渠道归属
export const QDGS_LIST = [
  { label: '全部', value: '' },
  { label: '渠道第一业务中心', value: '渠道第一业务中心' },
  { label: '渠道第二业务中心', value: '渠道第二业务中心' },
  { label: '区域和渠道中心', value: '区域和渠道中心' },
];

// 公共是否选择
export const REBATE_BOOL_LIST = [
  { label: '全部', value: '' },
  { label: '是', value: '是' },
  { label: '否', value: '否' },
];

// 客户签约模式
export const CUSTOME_CLASSIFY_LIST = [
  { label: 'F模式', value: 'F模式' },
  { label: 'G模式', value: 'G模式' },
  { label: 'L模式', value: 'L模式' },
  { label: '直签', value: '直签' },
];

export const INVEST_LEVEL_LIST = [
  { label: '全部', value: '' },
  { label: 'S', value: 'S' },
  { label: 'A', value: 'A' },
  { label: 'B', value: 'B' },
];

// 累量省份
export const LL_PROVINCE_LIST = [
  { label: '山东省', value: '山东省' },
  { label: '山西省', value: '山西省' },
  { label: '江苏省', value: '江苏省' },
  { label: '北京市', value: '北京市' },
  { label: '湖北省', value: '湖北省' },
  { label: '河北省', value: '河北省' },
  { label: '湖南省', value: '湖南省' },
  { label: '广西壮族自治区', value: '广西壮族自治区' },
  { label: '广东省', value: '广东省' },
  { label: '福建省', value: '福建省' },
  { label: '浙江省', value: '浙江省' },
  { label: '陕西省', value: '陕西省' },
  { label: '海南省', value: '海南省' },
  { label: '辽宁省', value: '辽宁省' },
  { label: '吉林省', value: '吉林省' },
  { label: '四川省', value: '四川省' },
  { label: '安徽省', value: '安徽省' },
  { label: '上海市', value: '上海市' },
  { label: '重庆市', value: '重庆市' },
  { label: '河南省', value: '河南省' },
  { label: '贵州省', value: '贵州省' },
  { label: '云南省', value: '云南省' },
  { label: '黑龙江省', value: '黑龙江省' },
  { label: '江西省', value: '江西省' },
  { label: '内蒙古自治区', value: '内蒙古自治区' },
  { label: '新疆维吾尔自治区', value: '新疆维吾尔自治区' },
  { label: '甘肃省', value: '甘肃省' },
  { label: '宁夏回族自治区', value: '宁夏回族自治区' },
  { label: '青海省', value: '青海省' },
  { label: '西藏自治区', value: '西藏自治区' },
];
